import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/material';
import { AnalyticsMetadataType } from 'graphql/types';
import { useAutoPilotContext } from 'modules/App/menu/items/Settings/AutoPilotContextProvider';
import UserSourceByTimeChart from '../components/SourceByTimeChart/UserSourceByTimeChart';
import { ClassificationBarChart } from '../components/NotesClassification/ClassificationBarChart';
import ClientChart from '../components/TimeSheetLabelCharts/ClientChart';
import ProgramChart from '../components/TimeSheetLabelCharts/ProgramChart';
import ProjectChart from '../components/TimeSheetLabelCharts/ProjectChart';
import TaskChart from '../components/TimeSheetLabelCharts/TaskChart';
import { OEFCharContainer } from '../components/TimeSheetLabelCharts/OEFCharts';
import OEFChartContextProvider from '../components/TimeSheetLabelCharts/OEFCharts/OEFChartContextProvider';
import UserUtilizationChart from '../components/UtilizationChart/UserUtilizationChart';
import { KeywordCloudChart } from '../components/BubbleChart/KeywordCloudChart';
import { AutoAccept } from '../components/AutoAcceptChart/AutoAccept';
import { UserHoursSummaryChart } from '../components/HoursSummaryChart/UserHoursSummaryChart';
import ActivityChart from '../components/TimeSheetLabelCharts/ActivityChart';
import { useLabelVisibility } from './hooks/useLabelVisibility';
import { useNoteInsightsContext } from './NoteInsightsContextProvider';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  itemContainer: {
    width: '30%'
  },
  itemClassification: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },

  rightDiv: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column'
  },
  labelChartGrid: {
    marginTop: theme.spacing(2)
  },
  bottomDiv: {
    display: 'flex'
  }
}));
const NotesInsightsFC: React.FC = () => {
  const classes = useStyles();
  const { currentPeriod } = useNoteInsightsContext();
  const labelVisibility = useLabelVisibility(currentPeriod!);
  const { isAutoPilotEnabled } = useAutoPilotContext();

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={classes.itemClassification}>
          <UserHoursSummaryChart />
          <ClassificationBarChart />
          {isAutoPilotEnabled && <AutoAccept />}
        </div>
        <div className={classes.bottomDiv}>
          <div className={classes.rightDiv}>
            <div>
              <UserUtilizationChart />
            </div>
            <Grid container className={classes.labelChartGrid}>
              {labelVisibility.CLIENT && (
                <Grid item xs={4}>
                  <ClientChart />
                </Grid>
              )}
              {labelVisibility.PROGRAM && (
                <Grid item xs={4}>
                  <ProgramChart />
                </Grid>
              )}
              {labelVisibility.PROJECT && (
                <Grid item xs={4}>
                  <ProjectChart />
                </Grid>
              )}
              {labelVisibility.TASK && (
                <Grid item xs={4}>
                  <TaskChart />
                </Grid>
              )}
            </Grid>
            <Grid container className={classes.labelChartGrid}>
              {labelVisibility.ACTIVITY && (
                <Grid item xs={4}>
                  <ActivityChart />
                </Grid>
              )}
              {labelVisibility.SELECT && (
                <OEFChartContextProvider
                  insightContext={useNoteInsightsContext}
                  AnalyticsMetadataInput={AnalyticsMetadataType.MetadataOefList}
                >
                  <OEFCharContainer />
                </OEFChartContextProvider>
              )}
            </Grid>
          </div>

          <div className={classes.itemContainer}>
            <div>
              <UserSourceByTimeChart />
              <KeywordCloudChart />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(NotesInsightsFC);
